// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2m3Y9","buttons":"SendReceipts_buttons__2Z9Gs","email":"SendReceipts_email__2fNDo","bookApptTitle":"SendReceipts_bookApptTitle__doZVX"};